import { IContainer } from '../../../common/container/IContainer';
import { signInPageContainer } from './login/signInPageContainer';

export function userPageContainer(container: IContainer): IContainer {
  container = signInPageContainer(container);
  return container;
}
